import IMask from 'imask';

import { PHONE_NUMBER_MASK, PHONE_NUMBER_MASK_9_DIGITS } from './constants';

export function phoneNumberFormatter(phoneNumber: string) {
  if (phoneNumber.length === 9) {
    return IMask.createPipe({ mask: PHONE_NUMBER_MASK_9_DIGITS })(phoneNumber);
  }

  return IMask.createPipe({ mask: PHONE_NUMBER_MASK })(phoneNumber);
}
